import { React, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

import SearchView from '../../Model/Individual/AccountModel/SearchView.js';
import useWindowSize from '../../Model/Share/Normal/useWindowSize.js';

// 아이디 및 비밀번호 찾기 페이지

function SearchIdentifierPage() {
  const size = useWindowSize();

  const [isOver, setIsOver] = useState(false);

  useEffect(() => {
    if (size.width >= 768) setIsOver(true);
    else setIsOver(false);
  }, [size])

  return (
    <Container>
      <SearchView isOver={isOver}/>
    </Container>
  );
}

export default SearchIdentifierPage;

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const Container = styled.div`
  // position: fixed;
  position: absolute;
  display: flex;

  justify-content: center;
  align-items: flex-start;

  gap: 132px;
  top: 0;
  left: 0;

  // width: 1920px;
  width: 100vw;
  min-height: 100vh;
  // height: 100vh;

  overflow-y: hidden;

  background-color: #FDFCFB;
  
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;